/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit FutureSeparator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Actions from './Actions/index'
import Indicator from './Indicator/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function FutureSeparator({
  children,
  viewPath = "/DesignSystem/TimelineEvent/FutureSeparator"
  
}) {
  let isMedia = useIsMedia()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let eventHasFutureEventsValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'hasFutureEvents',
format: fromHelpers.hasFutureEvents,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="FutureSeparator.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-ZhB4U8': dtColorsWhite,'--mt-2-ZhB4U8': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--w-3-ZhB4U8': isMedia.mobile ? "100%" : "990px"}}
 className={`views-block ${styles.Horizontal}`}
>
<Indicator
  viewPath={`${viewPath}/Indicator`}
/>
<div
  data-testid="FutureSeparator.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pt-4-ZhB4U8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 data="event.hasFutureEvents"
 format="helpers.js hasFutureEvents"
 text={eventHasFutureEventsValueData}
 level="h4"
 color={dtColorsNeutral500}
/>
<div
  data-testid="FutureSeparator.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}